import fetch from 'isomorphic-unfetch';
import { DataInput, DataPage } from '../hooks/use-data';

const QUERY = `
  query getData($input: DataRequest!) {
    data(input: $input) {
      content {
        id
        type
        json
      }
      totalPages
      totalElements
      number
      size
    }
  }
`;

const fetchData = async (
  input: DataInput,
  token?: string
): Promise<DataPage> => {
  const headers = {
    'X-CORE-SITE': 'VTI',
  };

  if (token) {
    headers['Authorization'] = 'Bearer ' + token;
  }

  return (
    await (
      await fetch(process.env.API_URL + '/graphql', {
        method: 'POST',
        body: JSON.stringify({
          query: QUERY,
          variables: {
            input,
          },
        }),
        headers,
      })
    ).json()
  ).data.data as DataPage;
};

export default fetchData;
